import { memo } from "react";
import PlannerCalendar from "@/components/appointmentRequest/assignmentPlanner/plannerCalendar";
import PlannerSlots, {
  PlannerSlotsProps,
} from "@/components/appointmentRequest/assignmentPlanner/plannerSlots";
import styles from "@/components/appointmentRequest/assignmentPlanner/planner.module.css";

interface Props extends PlannerSlotsProps {
  onDay: (day: string) => void;
  className?: string;
  initialScrollDay?: string;
  sideBySide?: boolean;
}
export default memo(function PlannerSlotWorkspace({
  onDay,
  className = "",
  initialScrollDay,
  sideBySide = false,
  ...props
}: Props) {
  return (
    <div
      className={`${styles.slotColumn} ${sideBySide ? styles.sideBySide : ""} ${className}`}
    >
      <PlannerCalendar
        slots={props.snapshot.slots}
        plan={props.plan}
        day={props.day}
        onDay={onDay}
        initialScrollDay={initialScrollDay}
      />
      <PlannerSlots {...props} />
    </div>
  );
});
